import React, {useState, useContext, useEffect} from 'react';

import AppStateContext from "../../context/appStateContext";
import PageLayout from "../../components/pageLayout";
import PageHeader from "../../components/pageHeader";

import ScheduleTable from "../../../components/scheduleTable";
import {CALLING,POPULATED,EMPTY,TIMEOUT} from "../../../components/apiStatus";
import GetAssetsListFunction from "../../../functions/GetAssetsListFunction";
import HeaderImg from "../../../assets/images/headerImages/maintenance_header.png";
import APIHelper from "../../../hooks/useAPIHelper";
import useFilterHelper from '../../../hooks/useFilterHelper';

import {
  PageHeaderText,
  AccessMessage
} from "./index.style";
import ICONS from "../../../assets/icons";

const MaintenanceSchedule:React.FC<any> = () => {

  const { selectedCustomerId, token, setAppPageDetails, userPermissionsList, siteLogo, contactEmail } = useContext(AppStateContext);
  const [ assetList, setAssetList ] = useState([]);
  const [ apiStatus, setApiStatus ] = useState(CALLING);

  const getAssets = APIHelper();
  const { filterByContractServices } = useFilterHelper();

  const assetsCallback =(data: [] | string) => {
    if(data == 'timeout' || data.length == 0){
      setApiStatus(EMPTY);
    } else if(data.length > 0) {
      setAssetList(filterByContractServices(data));
      setApiStatus(POPULATED);
    }
  };

  useEffect(() => {
    setAppPageDetails('maintenanceSchedule');
    let filter:string = `<Filters><CustomerCode><Like>${selectedCustomerId}</Like></CustomerCode></Filters>`;
    getAssets.run(GetAssetsListFunction,assetsCallback,[filter,token,selectedCustomerId]);
  },[]);

  return (
    <PageLayout>
      <PageHeader backgroundImg={siteLogo.background_image[3]['image']['url']}>
        <PageHeaderText>Maintenance Schedule</PageHeaderText>
      </PageHeader>
      {userPermissionsList.includes('view-schedule')?
        <ScheduleTable assetData={assetList} status={apiStatus}/>
        :
        <AccessMessage>
          <ICONS.alertTriangle/>
          <h2>You currently do not have permission to access this page, please contact {contactEmail}</h2>
        </AccessMessage>}
    </PageLayout>
  )
};

export default MaintenanceSchedule;

